import { Post, PostWithDetails, PublicPost } from '../../domain/models';

// Entity representing the database structure
export interface PostEntity {
  id: string;
  user_id: string;
  content: string;
  image_url?: string;
  tournament_id?: string;
  created_at: string;
  updated_at: string;
}

export interface PostWithDetailsEntity extends PostEntity {
  user_name?: string;
  user_email?: string;
  user_avatar_url?: string;
  tournament_name?: string;
  tournament_is_public?: boolean;
  like_count: number;
  is_liked_by_user: boolean;
}

// Mapper: from Entity (DB) to Model (Domain)
export const postEntityToModel = (entity: PostEntity): Post => {
  return {
    id: entity.id,
    userId: entity.user_id,
    content: entity.content,
    imageUrl: entity.image_url,
    tournamentId: entity.tournament_id,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
  };
};

export const postWithDetailsEntityToModel = (entity: PostWithDetailsEntity): PostWithDetails => {
  return {
    id: entity.id,
    userId: entity.user_id,
    content: entity.content,
    imageUrl: entity.image_url,
    tournamentId: entity.tournament_id,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
    userName: entity.user_name,
    userEmail: entity.user_email,
    userAvatarUrl: entity.user_avatar_url,
    tournamentName: entity.tournament_name,
    tournamentIsPublic: entity.tournament_is_public,
    likeCount: entity.like_count ?? 0,
    isLikedByUser: entity.is_liked_by_user ?? false,
  };
};

export interface PublicPostEntity extends PostEntity {
  user_name?: string;
  user_avatar_url?: string;
  tournament_name?: string;
  tournament_is_public: boolean;
  like_count: number;
}

export const publicPostEntityToModel = (entity: PublicPostEntity): PublicPost => ({
  id: entity.id,
  userId: entity.user_id,
  content: entity.content,
  imageUrl: entity.image_url,
  tournamentId: entity.tournament_id,
  createdAt: new Date(entity.created_at),
  updatedAt: new Date(entity.updated_at),
  userName: entity.user_name,
  userAvatarUrl: entity.user_avatar_url,
  tournamentName: entity.tournament_name,
  tournamentIsPublic: entity.tournament_is_public,
  likeCount: entity.like_count ?? 0,
});

// Mapper: from Model (Domain) to Entity (DB)
export const postModelToEntity = (model: Partial<Post>): Partial<PostEntity> => {
  return {
    id: model.id,
    user_id: model.userId,
    content: model.content,
    image_url: model.imageUrl,
    tournament_id: model.tournamentId,
    created_at: model.createdAt?.toISOString(),
    updated_at: model.updatedAt?.toISOString(),
  };
};
